module.exports = __webpack_public_path__ + "static/img/bottom.3b48e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/baoming2/bottom.png
// module id = f3Ah
// module chunks = 1